import React, { Component } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

// import Router from "./components/Router";
import Home from "./pages/home/Home";
import Project from "./pages/project/Project";
import Footer from "./components/footer/Footer";
import data from "./files/data";
import "./App.scss";

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: data
        };
    }

    render() {
        return (
            <BrowserRouter >
                <div id="content">
                    <Switch>
                        <Route
                            exact path={["/", "/projects/portfolio-website/demo"]}
                            render={(props) => <Home {...props} data={data} />}
                        />
                        <Route
                            path="/projects/:project"
                            render={(props) => <Project {...props} data={data} />}
                        />
                    </Switch>
                </div>
                <Footer data={this.state.data} />
            </BrowserRouter >
        );
    }
};

export default App;